export default __webpack_public_path__ + "static/media/BEE_LOGO.7f9e135c.png";